// thunks.js
import {
  fetchOrganizationRequest,
  fetchOrganizationSuccess,
  fetchOrganizationFailure,
  fetchLineMasterRequest,
  fetchLineMasterSuccess,
  fetchLineMasterFailure,
  loginRequest,
  loginSuccess,
  loginFailure,
  fetchSeasonRequest,
  fetchSeasonSuccess,
  fetchSeasonFailure,
  logout,
  fetchWarehouseRequest,
  fetchWarehouseSuccess,
  fetchWarehouseFailure,
  fetchADUserFailure,
  fetchADUserSuccess,
  fetchADUserRequest,
  fetchDguRemoteIPFailure,
  fetchDguRemoteIPSuccess,
  fetchDguRemoteIPRequest,
  fetchClientIPRequest,
  fetchClientIPSuccess,
  fetchClientIPFailure,
  // fetchDrierTypeRequest,
  // fetchDrierTypeSuccess,
  // fetchDrierTypeFailure,
} from "./actions";
import {
  fetchOrganizationData,
  fetchLineMasterData,
  loginService,
  fetchSeasonData,
  fetchWarehouseData,
  getClientIP,
  fetchDguRemoteIP,
  fetchADUser,
} from "../../service/web_service";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const fetchOrganizationThunk = (userId) => async (dispatch) => {
  dispatch(fetchOrganizationRequest());
  try {
    const response = await fetchOrganizationData(userId);
    dispatch(fetchOrganizationSuccess(response.data));
    // console.log(`fetchOrganizationThunk`, response.data);
  } catch (error) {
    dispatch(fetchOrganizationFailure(error.message));
  }
};

export const fetchLineMasterThunk = (orgId) => async (dispatch) => {
  dispatch(fetchLineMasterRequest());
  try {
    const response = await fetchLineMasterData(orgId);
    dispatch(fetchLineMasterSuccess(response.response.data));
    console.log(`fetchLineMasterThunk`, response.response.data);
  } catch (error) {
    dispatch(fetchLineMasterFailure(error.message));
  }
};
export const login_thunk = (payload) => {
  // console.log(payload);
  return async (dispatch) => {
    // dispatch(getClientIP());
    dispatch(loginRequest(payload)); // Dispatch login request action

    try {
      const response = await loginService(payload); // Await API call
      const getClient = await getClientIP();
      console.log("Login Response:", response);
      console.log("getClientIP Response:", getClient);

      if (response?.status === "OK" && response?.data?.length > 0) {
        dispatch(loginSuccess(response.data[0])); // Dispatch success with user data
        return response;
      } else {
        dispatch(loginFailure("Invalid Credentials"));
        return { error: "Invalid Credentials" };
      }
    } catch (err) {
      console.error("Login Error:", err);
      dispatch(loginFailure("Network Error"));
      return { error: "Network Error" };
    }
  };
};

// Fetch DGU Remote IP Thunk
export const fetchDguRemoteIPThunk = (userId) => {
  return async (dispatch) => {
    dispatch(fetchDguRemoteIPRequest());
    try {
      const response = await fetchDguRemoteIP(userId);
      dispatch(fetchDguRemoteIPSuccess(response.response));
    } catch (error) {
      dispatch(fetchDguRemoteIPFailure(error.message));
    }
  };
};

// Fetch AD User Thunk
export const fetchADUserThunk = (userId) => {
  return async (dispatch) => {
    dispatch(fetchADUserRequest());
    try {
      const response = await fetchADUser(userId);
      dispatch(fetchADUserSuccess(response.response));
    } catch (error) {
      dispatch(fetchADUserFailure(error.message));
    }
  };
};

export const logoutThunk = (navigate) => {
  return async (dispatch) => {
    dispatch(logout());
    try {
      await AsyncStorage.removeItem("username");
      await AsyncStorage.removeItem("password");
      await AsyncStorage.removeItem("userId");

      console.log("User data successfully removed from AsyncStorage.");

      navigate("/login");
    } catch (error) {
      console.error(`Logout Error: ${error}`);
    }
  };
};

// Thunk for fetching Season data
export const fetchSeasonThunk = () => async (dispatch) => {
  dispatch(fetchSeasonRequest());
  try {
    const response = await fetchSeasonData();
    dispatch(fetchSeasonSuccess(response.response.data));
    console.log(`fetchSeasonThunk`, response.response.data);
  } catch (error) {
    dispatch(fetchSeasonFailure(error.message));
  }
};


export const fetchWarehouseThunk = (warehouseId) => async (dispatch) => {
  dispatch(fetchWarehouseRequest());
  try {
    const response = await fetchWarehouseData(warehouseId);
    dispatch(fetchWarehouseSuccess(response.response));
    console.log(`fetchOrganizationThunk`, response.response);
  } catch (error) {
    dispatch(fetchWarehouseFailure(error.message));
  }
};

export const getClientIPThunk = () => async (dispatch) => {
  dispatch(fetchClientIPRequest());

  try {
    const ip = await getClientIP(); // getClientIP already returns data.ip

    if (!ip) {
      throw new Error("Failed to retrieve IP");
    }

    console.log("Client Public IP:", ip);
    dispatch(fetchClientIPSuccess(ip));
  } catch (error) {
    console.error("Error fetching client IP:", error);
    dispatch(fetchClientIPFailure(error.message));
  }
};
